import { workText } from "../../../data";
import ProjectCard from "./ProjectCard";
import { ProjectProps } from "./projectDetails";
import React from "react";

function ProjectGrid({
  projects,
  className,
}: {
  projects: ProjectProps[];
  className?: string;
}) {
  return (
    <>
      <div
        className={`grid w-[90%] grid-cols-1 grid-rows-2 gap-x-6 gap-y-10 lg:max-w-[1200px] lg:grid-cols-1 ${className}`}
      >
        {projects.map((project: ProjectProps) => (
          <ProjectCard
            id={project.id}
            key={project.id}
            name={project.name}
            description={project.description}
            technologies={project.technologies}
            techNames={project.techNames}
            techLinks={project.techLinks}
            github={project.github}
            demo={project.demo}
            image={project.image}
            video={project.video}
            available={project.available}
          />
        ))}
      </div>
    </>
  );
}

export default ProjectGrid;
